/*******************************************************************************
FILTERS DATA TO MATCH CHECKBOX FILTER
Runs the filter against a set of items attached to a checkbox filter.
*******************************************************************************/

import checkForMatch from '../filter-tabs/check-for-match';

export default function filterItems(settings) {

    const $items = $(settings.items);
    const hiddenClass = `hide--${settings.name}`;

    // Check each item to see if it matches the filter tab criteria
    $items.each((index, item) => {
        const $item = $(item);

        // Check to see if the current item matches the filter
        const filterMatches = checkForMatch($item, settings, settings);

        // Hide matching items if the checkbox is checked and the action is 'hide' OR if the checkbox is NOT checked and the action is 'show'
        if (filterMatches && ((settings.isChecked && settings.action === 'hide') || (!settings.isChecked && settings.action === 'show'))) {
            $item.addClass(hiddenClass);
        }

        // Show matching items if the checkbox is checked and the action is 'show' OR if the checkbox is NOT checked and the action is 'hide'
        if (filterMatches && ((settings.isChecked && settings.action === 'show') || (!settings.isChecked && settings.action === 'hide'))) {
            $item.removeClass(hiddenClass);
        }
    });
}
